import React from 'react'
import { useHistory, useLocation } from "react-router-dom";
import AnalyticsIcon from '@mui/icons-material/Analytics';
import ServiciosPendientesChart from './ServiciosPendientesChart';
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ThumbUpAlt from "@mui/icons-material/ThumbUpAlt";
import ThumbDownAlt from "@mui/icons-material/ThumbDownAlt";
import CircularProgress from "@mui/icons-material/HourglassTop";
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import CreditScoreIcon from '@mui/icons-material/CreditScore';

const GarantiasPanelDashboard = ({ sucursales, adr, ejercicio_inicio, ejercicio_fin, periodo_inicio, periodo_fin, filtroSucursales, garantias, encabezado }) => {
    const history = useHistory();
    const onGarantias = (idSeleccionado, estatus) => {
        history.push("/Postventa/Garantia", {
            idselected: idSeleccionado,
            sucursales: sucursales,
            adr: adr,
            ejercicio_inicio: ejercicio_inicio,
            ejercicio_fin: ejercicio_fin,
            periodo_inicio: periodo_inicio,
            periodo_fin: periodo_fin,
            filtroSucursales: filtroSucursales,
            estatus: estatus
        });
    };
    var idgarantia = 0;
    switch (encabezado) {
        case "Powergard Venta Temprana":
            idgarantia = 2;
            break;
        case "Powergard Venta Tardía":
            idgarantia = 3;
            break;
        case "Checklist":
            idgarantia = 4;
            break;
    }
    return (
        <div
            className="dashboard-postventa-tabla-garantias-container"
        >
            <div className="header">
                <AnalyticsIcon /> {encabezado}: {garantias.total_mensajes}
            </div>

            {/* Contenedor Flex para las tres secciones */}
            <div className="grid-scroll-wrapper">
                <div className="grid-layout">
                    {/* Sección 1 - Chart circular */}
                    <div className="chart-container" onClick={() => onGarantias(idgarantia, 'CC')}>
                        {window.innerWidth < 1480 ? null : (
                        <ServiciosPendientesChart
                            percentage={garantias.por_enviados}
                            size={90}
                        />
                        )}
                        <div className="vertical-divider"></div>
                        <div className="chart-summary">
                            <div className="detail-item">
                                <span>Total: </span>
                                <span> {garantias.total_mensajes} | 100%</span>
                            </div>
                            <div className="detail-item">
                                <span>Enviados: </span>
                                <span> {garantias.mensajes_enviados} | {garantias.por_enviados}%</span>
                            </div>
                            <div className="detail-item">
                                <span>Pendientes: </span>
                                <span> {garantias.mensajes_pendientes} | {garantias.por_mensajes_pendientes}%</span>
                            </div>
                            <div className="divider"></div>
                            <div className="detail-item">
                                <span> <CreditScoreIcon /> Facturados: </span>
                                <span> {garantias.facturados} | {garantias.por_facturados}%</span>
                            </div>
                        </div>
                    </div>

                    {/* Sección 2 - Tabla de estados */}
                    <div className="table-container estado-mensajes">
                        <table>
                            <tbody>
                                <tr onClick={() => onGarantias(idgarantia, 'ME' )}>
                                    <td>
                                        <WhatsAppIcon className="svg-color-green" />
                                    </td>
                                    <td>Enviados</td>
                                    <td>{garantias.mensajes_enviados}</td>
                                    <td>100 %</td>
                                </tr>
                                <tr onClick={() => onGarantias(idgarantia, 'LE')}>
                                    <td>
                                        <CircularProgress className="svg-color-blue" />
                                    </td>
                                    <td>Leídos</td>
                                    <td>{garantias.mensajes_leidos}</td>
                                    <td>{garantias.por_mensajes_leidos} %</td>
                                </tr>
                                <tr onClick={() => onGarantias(idgarantia, 'CI')}>
                                    <td>
                                        <ThumbUpAlt className="svg-color-green" />
                                    </td>
                                    <td>Interesados</td>
                                    <td>{garantias.cliente_con_interes}</td>
                                    <td>{garantias.por_cliente_con_interes} %</td>
                                </tr>
                                <tr onClick={() => onGarantias(idgarantia, 'SI')}>
                                    <td>
                                        <ThumbDownAlt className="svg-color-red" />
                                    </td>
                                    <td>No interesados</td>
                                    <td>{garantias.cliente_sin_interes}</td>
                                    <td>{garantias.por_cliente_sin_interes} %</td>
                                </tr>
                                <tr onClick={() => onGarantias(idgarantia, 'EO')}>
                                    <td>
                                        <ReportGmailerrorredIcon className="svg-color-red" />
                                    </td>
                                    <td>Error</td>
                                    <td>{garantias.error}</td>
                                    <td>{garantias.por_error} %</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GarantiasPanelDashboard